'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/node_modules/history/lib/ExecutionEnvironment.js
// module id = 136
// module chunks = 0